import { render, staticRenderFns } from "./DashboardTask.vue?vue&type=template&id=00507c84"
import script from "./DashboardTask.vue?vue&type=script&lang=js"
export * from "./DashboardTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports